<!-- Modal: World Map -->
<div class="modal fade" bsModal #installedLocationMap="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
  role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-events-name" class="modal-title pull-left">Worldwide Installation (Coming Soon...)</h4>
        <button 
          type="button"
          title="Close"
          class="close pull-right" 
          aria-label="Close" 
          (click)="closeInstalledLocationModel()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="charts.isWorldMapLoaded">
          <app-amcharts 
            [id]="'worldMap'" 
            [type]="'worldmap'"
            [data]="diseaseSplit" 
            [title]="'Installed Locations'"
            [valueField]="'FieldValue'" 
            [titleField]="'FieldName'" 
            [height]="600" 
          >
          </app-amcharts>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal: World Map ENDS -->

<!-- Modal: Expanded View Chart -->
<div class="modal fade" bsModal #chartExtendedView="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-events-name" class="modal-title pull-left">{{modalTitle}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeExpandedViewOfChart()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="isChartExtended">
        <div class="row" style="padding-top:10px;">
          <div class="col-xs-12" *ngFor="let chart of expandedChartsData">
            <app-amcharts *ngIf="chart.isLoaded"
              [id]="chart.id"
              [type]="chart.type"
              [title]="chart.title"
              [chartTitle]="chart.chartTitle"
              [data]="chart.chartData"
              [valueField]="chart.valueField" 
              [titleField]="chart.titleField"
              [isLegendShown]="'true'"
              [isExpandedView]="'true'"
              [height]="600"
              [theme]="'light'"
            >
            </app-amcharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal: Expanded View Chart ENDS -->

<div class="box">
  <!-- Row: Overall Information Row -->
  <div class="row" *ngIf="!isOverallDataRowLoaded">
    <div class="col-lg-12" style="max-height: 100px; height: 100px">
      <div class="ibox">
        <content-loader>
            <svg:rect x="0" y="0" rx="3" ry="3" width="100%" height="25px"/>
        </content-loader>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="isOverallDataRowLoaded">
    <div class="col-lg-2">
      <div class="ibox ">
        <div class="ibox-title">
          <div class="ibox-tools">
            <span class="float-right">
              <i class="fa fa-user-circle-o" style="color:#4fa746;font-size: 25px;"></i>
            </span>
          </div>
          <h5>Accounts</h5>
        </div>
        <div class="ibox-content" style="border-top:1px solid #4fa746;">
          <h1 class="no-margins" [countUp]="overallDetailsData.accountCount" [options]="{duration:2}"></h1>
          <small>Total Accounts <i class="fa fa-globe float-right" (click)="viewInstalledLocationMap()" style="font-size: 20px;color: cadetblue;cursor: pointer;"></i></small>
          <hr class="margin-top-bottom-2" />
          <h1 class="no-margins" [countUp]="overallDetailsData.accountCountCurrentDate" [options]="{duration:1}"></h1>
          <small>Today</small>
        </div>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="ibox ">
        <div class="ibox-title">
          <div class="ibox-tools">
            <span class="float-right">
              <i class="material-icons" style="color:#417bff;font-size: 25px;">group</i>
            </span>
          </div>
          <h5>Providers</h5>
        </div>
        <div class="ibox-content" style="border-top:1px solid #417bff;">
          <div class="row">
            <div class="col-md-12">
              <h1 class="no-margins" [countUp]="overallDetailsData.providerCount" [options]="{duration:2}"></h1>
              <small>Total Service Providers</small>
              <hr class="margin-top-bottom-2" />
              <h1 class="no-margins" [countUp]="overallDetailsData.providerCountCurrentDate" [options]="{duration:1}"></h1>
              <small>Today</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="ibox ">
        <div class="ibox-title">
          <div class="ibox-tools">
            <span class="float-right">
              <i style="color:#f3c010;font-size: 25px;" class="fa fa-user"></i>
            </span>
          </div>
          <h5>Patients</h5>
        </div>
        <div class="ibox-content" style="border-top:1px solid #f3c010;">
          <h1 class="no-margins" [countUp]="overallDetailsData.patientCount" [options]="{duration:2}"></h1>
          <small>Total Patients</small>
          <hr class="margin-top-bottom-2" />
          <h1 class="no-margins" [countUp]="overallDetailsData.patientCountCurrentDate" [options]="{duration:1}"></h1>
          <small>Today</small>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="ibox ">
        <div class="ibox-title">
          <h5>Visits <span style="font-size: 20px;color: #4fa2b9;" class="float-right" [countUp]="overallDetailsData.visitCount" [options]="{duration:2}"> </span></h5>
          <div class="ibox-tools">
            <span class="float-right">
            <i class="fa fa-eye" style="color:#4fa2b9;font-size: 25px;"></i>
          </span>
          </div>
        </div>
        <div class="ibox-content" style="border-top:1px solid #4fa2b9;">
          <div class="row">
            <div class="col-md-4" style="border-right: 1px  dotted #4fa2b9;">
              <h1 class="no-margins" [countUp]="overallDetailsData.fundusCount" [options]="{duration:2}"></h1>
              <small>Fundus</small>
              <hr class="margin-top-bottom-2" />
              <h1 class="no-margins" [countUp]="overallDetailsData.fundusCountCurrentDate" [options]="{duration:1}"></h1>
              <small>Today</small>
            </div>
            <div class="col-md-4" style="border-right: 1px dotted #4fa2b9;">
              <h1 class="no-margins" [countUp]="overallDetailsData.refractionCount" [options]="{duration:2}"></h1>
              <small>Refraction</small>
              <hr class="margin-top-bottom-2" />
              <h1 class="no-margins" [countUp]="overallDetailsData.refractionCountCurrentDate" [options]="{duration:1}"></h1>
              <small>Today</small>
            </div>
            <div class="col-md-4">
              <h1 class="no-margins" [countUp]="overallDetailsData.spectacleCount" [options]="{duration:2}"></h1>
              <small>Spectacle</small>
              <hr class="margin-top-bottom-2" />
              <h1 class="no-margins" [countUp]="overallDetailsData.spectacleCountCurrentDate" [options]="{duration:1}"></h1>
              <small>Today</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Row: Overall Information Row ENDS -->

  <!-- Row: Filter Row -->
  <div class="tile-progress bg-white text-left">
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
        <label>Select Date Range</label>
        <ngx-mat-drp 
          #dateRangePicker
          [options]="calendarOptions"
          (selectedDateRangeChanged)="updateDateRange($event)" 
        >
        </ngx-mat-drp>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
        <label>Select Account</label>
        <ng-select
          #filterAccount
          name="accounts"
          placeholder="Select account"
          bindLabel="accountName" 
          bindValue="accountId"
          [items]="accounts" 
          [clearable]="true" 
          [searchable]="true" 
          [(ngModel)]="accountId"
          (change)="getScreeningCentersByAccountID()"
          (clear)="clearFilterAccount()"
        >
        </ng-select>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" *ngIf="accountId !== null">
        <label>Select Screening Center</label>
        <ng-select
          #filterScreeningCenter
          name="screeingcenters"
          placeholder="Select screening center" 
          bindLabel="orgName"
          bindValue="orgId"
          [items]="screeningCenters" 
          [clearable]="true" 
          [searchable]="true"
          [(ngModel)]="orgId"
          (change)="screeningCenterSelected()"
          (clear)="clearFilterScreeningCenter()"
        >
        </ng-select>
      </div>
    </div>
  </div>
  <!-- Row: Filter Row ENDS-->

  <!-- Row: Services Taken + Disease Found -->
  <div class="row">
    <!-- Chart: Services Taken -->
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7">
      <div class="card-header">
        Services Utilized
        <!--<small class="filter-label">{{dateRangeView}}</small>-->
        <small class="filter-label">{{selectedDateRange.fromDate|date:customDateFormat}} - {{selectedDateRange.toDate|date:customDateFormat}}</small>
        <button *ngIf="charts.isServicesTakenLoaded && !charts.isServicesTakenError"
          type="button"
          title="Expand Chart"
          class="btn btn-xs btn-icon btn-circle btn-info float-right"
          (click)="showExpandedViewOfChart('servicesTaken', 'line')"
        >
          <i class="fa fa-expand"></i>
        </button>
      </div>
      <div class="content-body padding-top-20 padding-bottom-20">
        <div class="row">
          <content-loader *ngIf="!charts.isServicesTakenLoaded">
              <svg:rect x="0" y="0" rx="3" ry="3" width="100%" height="350" />
          </content-loader>
          <div *ngIf="charts.isServicesTakenError" class="chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> {{chartDataErrorMessage}}</span>
          </div>
          <app-amcharts *ngIf="charts.isServicesTakenLoaded && !charts.isServicesTakenError"
            [id]="'servicesTaken'" 
            [type]="'multiline'"
            [title]="'Services Taken'"
            [data]="chartsData.servicesTakenData" 
            [height]="350"
            [theme]="'light'"
          >
          </app-amcharts>
        </div>
      </div>
    </div>
    <!-- Chart: Services Taken ENDS-->

    <!-- Chart: Disease Found -->
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5">
      <div class="card-header">
        Disease Found
        <!--<small class="filter-label">{{dateRangeView}}</small>-->
        <small class="filter-label">{{selectedDateRange.fromDate|date:customDateFormat}} - {{selectedDateRange.toDate|date:customDateFormat}}</small>
        <button *ngIf="charts.isDiseaseFoundLoaded && !charts.isDiseaseFoundError"
          type="button" 
          class="btn btn-xs btn-icon btn-circle btn-info float-right" 
          title="Expand Chart"
          (click)="showExpandedViewOfChart('diseasesFound', 'pie')"
        >
          <i class="fa fa-expand"></i>
        </button>
        <button *ngIf="charts.isDiseaseFoundLoaded && !charts.isDiseaseFoundError"
          type="button"
          class="btn btn-xs btn-icon btn-circle btn-warning float-right margin-r5" 
          title="Show Line Chart Version" 
          (click)="showExpandedViewOfChart('diseasesFound', 'line')"
          >
          <i class="fa fa-line-chart"></i>
        </button>
      </div>
      <div class="content-body padding-top-20 padding-bottom-20">
          <content-loader height="265" *ngIf="!charts.isDiseaseFoundLoaded">
            <svg:circle cx="200" cy="100" r="95"/>
          </content-loader>
          <div *ngIf="charts.isDiseaseFoundError" class="chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> {{chartDataErrorMessage}}</span>
          </div>
          <app-amcharts *ngIf="charts.isDiseaseFoundLoaded && !charts.isDiseaseFoundError"
            [id]="'diseasesFound'"
            [type]="'pie'"
            [title]="'Disease Found'"
            [data]="chartsData.diseaseFoundData.pie"
            [valueField]="'fieldValue'" 
            [titleField]="'fieldName'" 
            [height]="350"
            [theme]="'light'"
          >
          </app-amcharts>
      </div>
    </div>
    <!-- Chart: Disease Found ENDS-->
  </div>
  <!-- Row: Services Taken + Disease Found ENDS-->

  <!-- Row: Package Subscription History + Payment Split -->
  <div class="row" style="margin-top:15px;" *ngIf="sectionScrolled >= 20">
    <!-- Chart: Package Subscription History -->
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7">
      <div class="card-header">
        Package Subscription History
        <!--<small class="filter-label">{{dateRangeView}}</small>-->
        <small class="filter-label">{{selectedDateRange.fromDate|date:customDateFormat}} - {{selectedDateRange.toDate|date:customDateFormat}}</small>
        <button *ngIf="charts.isPackageSubscriptionHistoryLoaded && !charts.isPackageSubscriptionHistoryError"
          type="button"
          title="Expand Chart"
          class="btn btn-xs btn-icon btn-circle btn-info float-right"
          (click)="showExpandedViewOfChart('packageSubscription', 'line')"
        >
          <i class="fa fa-expand"></i>
        </button>
      </div>
      <div class="content-body padding-top-20 padding-bottom-20">
        <div class="row">
          <content-loader *ngIf="!charts.isPackageSubscriptionHistoryLoaded">
            <svg:rect x="0" y="0" rx="3" ry="3" width="100%" height="350" />
          </content-loader>
          <div *ngIf="charts.isPackageSubscriptionHistoryError" class="chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> {{chartDataErrorMessage}}</span>
          </div>
          <app-amcharts *ngIf="charts.isPackageSubscriptionHistoryLoaded && !charts.isPackageSubscriptionHistoryError"
            [id]="'subscriptionHistory'" 
            [type]="'multiline'"
            [title]="'Package Transaction'"
            [data]="chartsData.packageSubscriptionHistoryData" 
            [height]="350" 
            [theme]="'light'"
          >
        </app-amcharts>
        </div>
      </div>
    </div>
    <!-- Chart: Package Subscription History ENDS-->

    <!-- Chart: Payment History -->
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5">
      <div class="card-header">
        Payment History
        <!--<small class="filter-label">{{dateRangeView}}</small>-->
        <small class="filter-label">{{selectedDateRange.fromDate|date:customDateFormat}} - {{selectedDateRange.toDate|date:customDateFormat}}</small>
        <button *ngIf="charts.isPaymentHistoryLoaded && !charts.isPaymentHistoryError"
          type="button"
          class="btn btn-xs btn-icon btn-circle btn-info float-right"
          title="Expand Chart"
          (click)="showExpandedViewOfChart('paymenthistory', 'pie')"
        >
          <i class="fa fa-expand"></i>
        </button>
        <!-- Line chart for this currently disabled -->
        <!-- <button 
          type="button"
          class="btn btn-xs btn-icon btn-circle btn-warning float-right margin-r5" 
          title="Expand Chart"
        >
          <i class="fa fa-line-chart"></i>
        </button> -->
      </div>
      <div class="content-body padding-top-20 padding-bottom-20">
        <div class="row">
          <content-loader height="250" *ngIf="!charts.isPaymentHistoryLoaded">
            <svg:circle cx="200" cy="100" r="95"/>
          </content-loader>
          <div *ngIf="charts.isPaymentHistoryError" class="chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> {{chartDataErrorMessage}}</span>
          </div>
          <app-amcharts *ngIf="charts.isPaymentHistoryLoaded && !charts.isPaymentHistoryError"
            [id]="'paymenthistory'" 
            [type]="'pie'"
            [title]="'Payment History'"
            [data]="chartsData.paymentHistoryData.pie"
            [valueField]="'fieldValue'" 
            [titleField]="'fieldName'" 
            [height]="350"
            [theme]="'light'"
          >
          </app-amcharts>
        </div>
      </div>
    </div>
    <!-- Chart: Payment History ENDS-->
  </div>
  <!-- Row: Package Subscription History + Payment Split ENDS-->

  <!-- Row: Patients Statistics -->
  <div class="row" style="margin-top:15px;" *ngIf="sectionScrolled >= 40">
    <div class="col-xs-12">
      <div class="card-header">
        Patients Statistics
        <!--<small class="filter-label">{{dateRangeView}}</small>-->
        <small class="filter-label">{{selectedDateRange.fromDate|date:customDateFormat}} - {{selectedDateRange.toDate|date:customDateFormat}}</small>
        <button *ngIf="charts.isPatientsStatisticsLoadedSex || charts.isPatientsStatisticsLoadedAge && (!charts.isPatientsStatisticsLoadedSexError || !charts.isPatientsStatisticsLoadedAgeError)"
          type="button"
          class="btn btn-xs btn-icon btn-circle btn-info float-right"
          title="Expand Chart"
          (click)="showExpandedViewOfChart('patients', 'pie')"
        >
          <i class="fa fa-expand"></i>
        </button>
        <button *ngIf="charts.isPatientsStatisticsLoadedSex || charts.isPatientsStatisticsLoadedAge && (!charts.isPatientsStatisticsLoadedSexError || !charts.isPatientsStatisticsLoadedAgeError)"
          type="button"
          class="btn btn-xs btn-icon btn-circle btn-warning float-right margin-r5"
          title="Show Line Chart Version"
          (click)="showExpandedViewOfChart('patients', 'line')"
        >
          <i class="fa fa-line-chart"></i>
        </button>
      </div>
      <div class="content-body padding-top-20 padding-bottom-20">
        <div class="row">
          <!-- Patients: Sex Chart -->
          <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="!charts.isPatientsStatisticsLoadedSex">
            <content-loader height="200">
              <svg:circle cx="200" cy="100" r="95"/>
            </content-loader>
          </div>
          <div *ngIf="charts.isPatientsStatisticsLoadedSexError" class="col-xs-12 col-sm-12 col-md-6 chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> Patients' Sex: {{chartDataErrorMessage}}</span>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6">
            <app-amcharts *ngIf="charts.isPatientsStatisticsLoadedSex && !charts.isPatientsStatisticsLoadedSexError"
              [id]="'patientsSex'" 
              [type]="'pie'"
              [title]="'Patients Sex'"
              [chartTitle]="'Gender'"
              [data]="chartsData.patientsStatisticsSexData.pie"
              [valueField]="'fieldValue'" 
              [titleField]="'fieldName'" 
              [height]="350"
              [theme]="'light'"
            >
            </app-amcharts>
          </div>
          <!-- Patients: Sex Chart ENDS -->

          <!-- Patients: Age Chart -->
          <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="!charts.isPatientsStatisticsLoadedAge">
            <content-loader height="200">
              <svg:circle cx="200" cy="100" r="95"/>
            </content-loader>
          </div>
          <div *ngIf="charts.isPatientsStatisticsLoadedAgeError" class="col-xs-12 col-sm-12 col-md-6 chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> Patients' Age: {{chartDataErrorMessage}}</span>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="charts.isPatientsStatisticsLoadedAge && !charts.isPatientsStatisticsLoadedAgeError">
            <app-amcharts
              [id]="'patientsAge'"
              [type]="'pie'"
              [title]="'Patients Age'"
              [chartTitle]="'Age'"
              [data]="chartsData.patientsStatisticsAgeData.pie"
              [valueField]="'fieldValue'" 
              [titleField]="'fieldName'" 
              [height]="350"
              [theme]="'light'"
            >
            </app-amcharts>
          </div>
          <!-- Patients: Age Chart ENDS -->
        </div>
      </div>
    </div>
  </div>
  <!-- Row: Patient Statistics ENDS -->

  <!-- Row: Fundus Statistics -->
  <div class="row" style="margin-top:15px;" *ngIf="sectionScrolled >= 60">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="card-header">
        Fundus Statistics
        <!--<small class="filter-label">{{dateRangeView}}</small>-->
        <small class="filter-label">{{selectedDateRange.fromDate|date:customDateFormat}} - {{selectedDateRange.toDate|date:customDateFormat}}</small>
        <button *ngIf="charts.isFundusStatisticsLoadedStatus || charts.isFundusStatisticsLoadedDevice && (!charts.isFundusStatisticsLoadedStatusError || !charts.isFundusStatisticsLoadedDeviceError)"
          type="button" 
          title="Expand Chart"
          class="btn btn-xs btn-icon btn-circle btn-info float-right"
          (click)="showExpandedViewOfChart('fundus', 'pie')"
        >
          <i class="fa fa-expand"></i>
        </button>
        <button *ngIf="charts.isFundusStatisticsLoadedStatus || charts.isFundusStatisticsLoadedDevice && (!charts.isFundusStatisticsLoadedStatusError || !charts.isFundusStatisticsLoadedDeviceError)"
          type="button"
          title="Show Line Chart Version"
          class="btn btn-xs btn-icon btn-circle btn-warning float-right margin-r5"
          (click)="showExpandedViewOfChart('fundus', 'line')"
        >
          <i class="fa fa-line-chart"></i>
        </button>
      </div>
      <div class="content-body padding-top-20 padding-bottom-20">
        <div class="row">
          <!-- Fundus Status Chart (PIE) -->
          <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="!charts.isFundusStatisticsLoadedStatus">
            <content-loader height="200">
              <svg:circle cx="200" cy="100" r="95"/>
            </content-loader>
          </div>
          <div *ngIf="charts.isFundusStatisticsLoadedStatusError" class="col-xs-12 col-sm-12 col-md-6 chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> Fundus Status: {{chartDataErrorMessage}}</span>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="charts.isFundusStatisticsLoadedStatus && !charts.isFundusStatisticsLoadedStatusError">
            <app-amcharts 
              [id]="'fundusStatus'"
              [type]="'pie'"
              [title]="'Fundus Status'"
              [chartTitle]="'Status'"
              [data]="chartsData.fundusStatisticsStatus.pie" 
              [valueField]="'fieldValue'" 
              [titleField]="'fieldName'" 
              [height]="350"
              [theme]="'light'"
            >
            </app-amcharts>
          </div>
          <!-- Fundus Status Chart (PIE) ENDS -->

          <!-- Fundus Device Chart (PIE) -->
          <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="!charts.isFundusStatisticsLoadedDevice">
            <content-loader height="200">
              <svg:circle cx="200" cy="100" r="95"/>
            </content-loader>
          </div>
          <div *ngIf="charts.isFundusStatisticsLoadedDeviceError" class="col-xs-12 col-sm-12 col-md-6 chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> Fundus Device: {{chartDataErrorMessage}}</span>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="charts.isFundusStatisticsLoadedDevice && !charts.isFundusStatisticsLoadedDeviceError">
            <app-amcharts
              [id]="'fundusDevice'" 
              [type]="'pie'"
              [title]="'Fundus Device'"
              [chartTitle]="'Devices'"
              [data]="chartsData.fundusStatisticsDevice.pie"
              [valueField]="'fieldValue'" 
              [titleField]="'fieldName'" 
              [height]="350"
              [theme]="'light'"
            >
            </app-amcharts>
          </div>
          <!-- Fundus Device Chart (PIE) -->
        </div>
      </div>
    </div>
  </div>
  <!-- Row: Fundus Statistics ENDS-->

  <!-- Row: AI Gradeability/Diagnosis Statistics -->
  <div class="row" style="margin-top:15px;" *ngIf="sectionScrolled >= 80">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="card-header">
        AI Gradeability/Diagnosis Statistics
        <!--<small class="filter-label">{{dateRangeView}}</small>-->
        <small class="filter-label">{{selectedDateRange.fromDate|date:customDateFormat}} - {{selectedDateRange.toDate|date:customDateFormat}}</small>
        <button *ngIf="charts.isAIGradeabilityLoaded || charts.isAIDiagnosisLoaded && (!charts.isAIGradeabilityLoadedError || !charts.isAIDiagnosisLoadedError)"
          type="button"
          title="Expand Chart"
          class="btn btn-xs btn-icon btn-circle btn-info float-right"
          (click)="showExpandedViewOfChart('aiStatistics', 'pie')"
        >
          <i class="fa fa-expand"></i>
        </button>
        <button *ngIf="charts.isAIGradeabilityLoaded || charts.isAIDiagnosisLoaded && (!charts.isAIGradeabilityLoadedError || !charts.isAIDiagnosisLoadedError)"
          type="button"
          title="Show Line Chart Version"
          class="btn btn-xs btn-icon btn-circle btn-warning float-right margin-r5"
          (click)="showExpandedViewOfChart('aiStatistics', 'line')"
        >
          <i class="fa fa-line-chart"></i>
        </button>
      </div>
      <div class="content-body padding-top-20 padding-bottom-20">
        <div class="row">
          <!-- AI Gradeability Chart (PIE) -->
          <div class="col-xs-12 col-sm-6" *ngIf="!charts.isAIGradeabilityLoaded">
            <content-loader height="200">
              <svg:circle cx="200" cy="100" r="95"/>
            </content-loader>
          </div>
          <div *ngIf="charts.isAIGradeabilityLoadedError" class="col-xs-12 col-sm-12 col-md-6 chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> AI Gradeability: {{chartDataErrorMessage}}</span>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="charts.isAIGradeabilityLoaded && !charts.isAIGradeabilityLoadedError">
            <app-amcharts 
              [id]="'aiGradeable'"
              [type]="'pie'"
              [title]="'AI Gradeable'"
              [chartTitle]="'Gradeability'"
              [data]="chartsData.aiGradeabilityData.pie" 
              [valueField]="'fieldValue'" 
              [titleField]="'fieldName'" 
              [height]="350" 
              [theme]="'light'"
            >
            </app-amcharts>
          </div>
          <!-- AI Gradeability Chart (PIE) ENDS -->

          <!-- AI Diagnosis Chart (PIE) -->
          <div class="col-xs-12 col-sm-6" *ngIf="!charts.isAIDiagnosisLoaded">
            <content-loader height="200">
              <svg:circle cx="200" cy="100" r="95"/>
            </content-loader>
          </div>
          <div *ngIf="charts.isAIDiagnosisLoadedError" class="col-xs-12 col-sm-12 col-md-6 chartdata-error-message">
            <span><i class="fa fa-times-circle fa-4" aria-hidden="true"></i> AI Diagnosis: {{chartDataErrorMessage}}</span>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="charts.isAIDiagnosisLoaded && !charts.isAIDiagnosisLoadedError">
            <app-amcharts 
              [id]="'aiDiagonsis'" 
              [type]="'pie'"
              [title]="'AI Diagnosis'"
              [chartTitle]="'Diagnosis'"
              [data]="chartsData.aiDiagnosisData.pie" 
              [valueField]="'fieldValue'" 
              [titleField]="'fieldName'" 
              [height]="350"
              [theme]="'light'"
            >
            </app-amcharts>
          </div>
          <!-- AI Diagnosis Chart (PIE) ENDS -->
        </div>
      </div>
    </div>
  </div>
  <!-- Row: AI Gradeability/Diagnosis Statistics ENDS-->

  <!-- Comparitive AI Chart disabled for now -->
  <!-- <div class="row" style="margin-top:15px;" *ngIf="sectionScrolled >= 100">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="card-header">
        AI Gradeability/Diagnosis Statistics Comparative Analysis
        <small class="filter-label">{{dateRangeView}}</small>
        <a class="btn btn-xs btn-icon btn-circle btn-info float-right"><i class="fa fa-expand"></i></a>
      </div>
      <div class="content-body padding-top-20 padding-bottom-20">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <app-amcharts [id]="'serviceprovidersplit414'" [data]="aiAnalysisData" [title]="'Disease Found'"
              [height]="350" [type]="'comparative-multi-line'">
            </app-amcharts>
          </div>
        </div>
      </div>
    </div>
  </div> -->

</div>